/**
 * Generated from StartScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function StartScreenLayout(this: $StartScreenLayout) {
	$(this, "main", main, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	$(this, "background", background, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "buttonPlay", buttonPlay, {x:3.5, y:47.25, w:377.00, h: 383.99});
	$(this, "loader", loader, {x:3.35, y:33.25, w:335.24, h: 335.24});
	return this;
}
function background(this: $background) {
	if (this.setLayoutTexture) this.setLayoutTexture("splash.jpg", 0.000, 0.000);
	return this;
}
function buttonPlay(this: $buttonPlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-play.png", 0.501, 0.500);
	return this;
}
function loader(this: $loader) {
	if (this.setLayoutTexture) this.setLayoutTexture("loader.png", 0.501, 0.501);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $StartScreenLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly background: $background;
	readonly buttonPlay: $buttonPlay;
	readonly loader: $loader;
}
interface $background extends $$sprite {
}
interface $buttonPlay extends $$sprite {
}
interface $loader extends $$sprite {
}
